<template>
  <FiltersDesktop
    v-model:filtersValues="filtersValues"
    class="mt-32 hidden md:block"
    :currencies-options="filtersMetadata.currenciesOptions"
    :resetFilters
    :submitFilters
    :time-periods-options="filtersMetadata.timePeriodsOptions"
  />
  <FiltersMobile
    v-model:filtersValues="filtersValues"
    class="md:hidden"
    :currencies-options="filtersMetadata.currenciesOptions"
    :resetFilters
    :submitFilters
    :time-periods-options="filtersMetadata.timePeriodsOptions"
  />
</template>

<script setup lang="ts">
import { merchantsAPI } from '@backmarket/http-api'
import type { GetFinancialReportMetadataResponse } from '@backmarket/http-api/src/api-specs-seller-backoffice/merchants/financial-report.types'
import { useHttpFetch } from '@backmarket/nuxt-module-http/useHttpFetch'
import type { Option } from '@ds/components/InputSelect'

import type { FilterValues } from './Filters.types'
import FiltersDesktop from './components/FiltersDesktop/FiltersDesktop.vue'
import FiltersMobile from './components/FiltersMobile/FiltersMobile.vue'

const filtersValues = defineModel<FilterValues>('filtersValues', {
  required: true,
})

defineProps<{
  resetFilters: () => void
  submitFilters: () => void
}>()

const { data: filtersMetadata } = await useHttpFetch(
  merchantsAPI.getFinancialReportMetadata,
  {
    transform: (
      data: GetFinancialReportMetadataResponse,
    ): Record<string, Option[]> => {
      return {
        currenciesOptions: data.currencies?.map((currency) => ({
          label: currency.label,
          value: currency.code,
        })),
        timePeriodsOptions: data.timePeriods?.map((period) => ({
          label: period.label,
          value: period.code,
        })),
      }
    },
    default: (): Record<string, Option[]> => {
      return {
        currenciesOptions: [],
        timePeriodsOptions: [],
      }
    },
  },
)
</script>
